import { assert } from '../../lib/assert-sidecar'
import { common } from '../../main/common-sidecar'
import { EVoyageCrewType, IVoyageCrew } from './voyageCrew'
import { voyageCrew } from './voyageCrew-sidecar'
import { voyageFakeInfo } from './voyageFakeInfo-sidecar'
import type { IVoyageSystemState } from './voyageSystems'
import { voyageTilemap } from './voyageTilemap-sidecar'

export function onCreate(sys: IVoyageSystemState) {
  sys.frozenCrewName = voyageFakeInfo.genFakeName()
}

export function crewUpdate(obj: IVoyageCrew) {
  let ds = common.getUpdateDeltaScaled()
  let d = obj.crewState
  assert.notNil(d)

  let useSystemTime = 3
  d.useSystemTimer += ds
  if (d.useSystemTimer > useSystemTime) {
    d.useSystemTimer -= useSystemTime

    let tHere = voyageTilemap.getSafeIJ(obj)
    assert.notNil(tHere)

    let sd = tHere.system
    assert.notNil(sd)

    if (sd.ammo > 0) {
      sd.ammo--

      let cr = voyageCrew.create(EVoyageCrewType.Crew, 0)
      cr.name = sd.frozenCrewName || cr.name
      voyageCrew.moveToIJ(cr, { i: tHere.i, j: tHere.j + 1 })
    } else {
      voyageCrew.say(obj, 'Cryo chamber is empty')
    }
  }
}
